import Vue from 'vue';
import Vuex from 'vuex'
import vueMoment from 'vue-moment';
const moment = require('moment');
if(window.locale !== undefined && window.locale !== 'en') {
    require('moment/locale/' + window.locale);
}

import PermissionService from "../services/PermissionService";
import Lang from 'lang.js';

Vue.use(Vuex);
Vue.use(vueMoment, {moment});

const store = new Vuex.Store({
    state: {
        loaded: false,
        loading: false,
        subscribed: true,
        onTrial: false,
        authenticated: false,
        overlay: false,
        user: null,
        userSettings: null,
        company: null,
        companySettings: null,
        timeOption: null,
        lastTimesheet: null,
        isConnectedToQuickbooks: false,
        isConnectedToXero: false,
        xeroHasError403: false,
        members: [],
        invites: [],
        shareInviteEnabled : false,
        shareInviteUrl : null,
        thisWeek: {
            from: "",
            to: ""
        },
        period: {
            from: "",
            to: ""
        },
        activities: [],
        markers: [],
        permission: {
            canAccessActivity: false,
            canAccessAllTimesheets: false,
            canAccessBilling: false,
            canAccessSettings: false,
            canAccessManageTeam: false,
            canManageEntries: false
        },
        labels: [],
        userLicense: {
            enabled: false,
            license: null
        },
        archivedMembers: [],
        showCustomPassportLicenseNumber: false,
        showArchivedMembers : false,
        weekdays: [],
        payrollSchedulers: [],
        companyJobs: [],
        companyDepartments: [],
        companyPto: [],
        jobSites: [],
        breakCodes: [],
        currencies: [],
        timeClockTicker: null,
        breakClockTicker: null,
        countries: [],
        companyHolidays: [],
        payroll_checkhq_web_enabled: false,
        checkhq_payroll_url: null
    },
    mutations: {
        loggedIn (state) {
            state.authenticated = true;
        },
        loggedOut (state) {
            state.authenticated = false;
        },
        showLoading (state) {
            state.loading = true;
        },
        hideLoading (state) {
            state.loading = false;
        },
        overlay (state, value) {
            state.overlay = value;
        },
        contentLoaded (state) {
            state.loaded = true;
        },
        subscribed(state, value) {
          state.subscribed = value;
        },
        onTrial(state, value) {
            state.onTrial = value;
        },
        user (state, user){
            user.intro_step = JSON.parse(user.intro_step);
            state.user = user;
            state.permission = PermissionService.getPermissions(state.user, state.company.user_id, state.companySettings);
            state.user.is_owner = user.id === state.company.user_id;
        },
        userSettings (state, settings){
            state.userSettings = settings;
        },
        company (state, company){
            state.company = company;
        },
        companySettings (state, settings){
            state.companySettings = settings;
        },
        timeOption (state, options){
            state.timeOption = options;
        },
        lastTimesheet (state, item){
            state.lastTimesheet = item;
        },
        isConnectedToQuickbooks(state, value){
          state.isConnectedToQuickbooks = value;
        },
        isConnectedToXero(state, value){
            state.isConnectedToXero = value;
        },
        xeroHasError403(state, value){
            state.xeroHasError403 = value;
        },
        members (state, members){
            state.members = members;
        },
        invites (state, invites){
            state.invites = invites;
        },
        thisWeek (state, thisWeek){
            state.thisWeek = thisWeek;
            state.period = {
                from: thisWeek.from,
                to: thisWeek.to,
                fromFormatted: Vue.moment(thisWeek.from).format('MMM D, YYYY'),
                toFormatted: Vue.moment(thisWeek.to).format('MMM D, YYYY')
            }
        },
        period (state, selectedPeriod) {
            state.period = selectedPeriod;
        },
        activities (state, data) {
            state.activities = data;
        },
        markers (state, data) {
            state.markers = data;
        },
        labels(state, data) {
            state.labels = data;
            Vue.prototype.label = new Lang({
                messages: state.labels,
                locale: state.userSettings.locale,
                fallback: 'en'
            });
        },
        shareInviteEnabled(state, data){
            state.shareInviteEnabled = data;
        },
        shareInviteUrl(state, data){
            state.shareInviteUrl = data;
        },
        userLicense(state, data){
            state.userLicense = data;
        },
        archivedMembers (state, members){
            state.archivedMembers = members;
        },
        showArchivedMembers(state, data){
            state.showArchivedMembers = data;
        },
        showCustomPassportLicenseNumber(state, data){
            state.showCustomPassportLicenseNumber = data;
        },
        weekdays (state, items){
            state.weekdays = items;
        },
        payrollSchedulers (state, items){
            state.payrollSchedulers = items;
        },
        companyJobs (state, jobs){
            state.companyJobs = jobs;
        },
        companyDepartments (state, departments){
            state.companyDepartments = departments
        },
        companyPto (state, ptos){
            state.companyPto = ptos;
        },
        jobSites (state, items){
            state.jobSites = items;
        },
        breakCodes (state, items){
            state.breakCodes = items;
        },
        currencies (state, items){
            state.currencies = items;
        },
        timeClockTicker(state, time) {
            state.timeClockTicker = time;
        },
        breakClockTicker(state, time) {
            state.breakClockTicker = time;
        },
        countries (state, items){
            state.countries = items;
        },
        payrollCheckHQEnabled (state, value) {
            state.payroll_checkhq_web_enabled = value;
        },
        payrollCheckHQUrl (state, value) {
            state.checkhq_payroll_url = value;
        }
    },
    getters: {
        subscribed: state => {
            return state.subscribed;
        },
        onTrial: state => {
            return state.onTrial;
        },
        user: state => {
            return state.user
        },
        userSettings: state => {
            return state.userSettings;
        },
        company: state => {
            return state.company;
        },
        companySettings: state => {
            return state.companySettings;
        },
        timeOption: state => {
            return state.timeOption;
        },
        lastTimesheet: state => {
            return state.lastTimesheet;
        },
        isConnectedToQuickbooks : state => {
          return state.isConnectedToQuickbooks;
        },
        isConnectedToXero : state => {
            return state.isConnectedToXero;
        },
        xeroHasError403 : state => {
            return state.xeroHasError403;
        },
        members: state => {
            return state.members;
        },
        invites: state => {
            return state.invites;
        },
        thisWeek: state => {
            return state.thisWeek;
        },
        period: state => {
            return state.period;
        },
        markers: state => {
            return state.markers;
        },
        labels: state => {
            return state.labels;
        },
        shareInviteEnabled: state => {
            return state.shareInviteEnabled;
        },
        shareInviteUrl: state => {
            return state.shareInviteUrl;
        },
        userLicense: state => {
            return state.userLicense;
        },
        archivedMembers: state => {
            return state.archivedMembers;
        },
        showArchivedMembers: state => {
            return state.showArchivedMembers;
        },
        showCustomPassportLicenseNumber: state => {
            return state.showCustomPassportLicenseNumber;
        },
        weekdays: state => {
            return state.weekdays;
        },
        payrollSchedulers: state => {
            return state.payrollSchedulers
        },
        companyJobs: state => {
            return state.companyJobs;
        },
        companyDepartments: state => {
            return state.companyDepartments
        },
        companyPto: state => {
            return state.companyPto;
        },
        jobSites: state => {
            return state.jobSites;
        },
        breakCodes: state => {
            return state.breakCodes;
        },
        currencies: state => {
            return state.currencies;
        },
        timeClockTicker: state => {
            return state.timeClockTicker;
        },
        breakClockTicker: state => {
            return state.breakClockTicker;
        },
        countries: state => {
            return state.countries;
        },
        payrollCheckHQEnabled: state => {
            return state.payroll_checkhq_web_enabled;
        },
        payrollCheckHQUrl: state => {
            return state.checkhq_payroll_url;
        }
    }
});

export default store